module.exports = __webpack_public_path__ + "img/BE0471833041.1befe781.png";